/**
 *
 * @param {string} name
 * @returns
 */

const url = `app`;

export const LOAD_DYNAMIC_IMAGES_LIST = `${url}/LOAD_DYNAMIC_IMAGES_LIST`;
export const LOAD_DYNAMIC_IMAGES_LIST_SUCCESS = `${url}/LOAD_DYNAMIC_IMAGES_LIST_SUCCESS`;
export const LOAD_DYNAMIC_IMAGES_LIST_ERROR = `${url}/LOAD_DYNAMIC_IMAGES_LIST_ERROR`;
export const LOAD_DESTINATION_LIST = `${url}/LOAD_DESTINATION_LIST`;
export const LOAD_DESTINATION_LIST_SUCCESS = `${url}/LOAD_DESTINATION_LIST_SUCCESS`;
export const LOAD_DESTINATION_LIST_ERROR = `${url}/LOAD_DESTINATION_LIST_ERROR`;
export const LOAD_PACKAGES_CATEGORY_LIST = `${url}/LOAD_PACKAGES_CATEGORY_LIST`;
export const LOAD_PACKAGES_CATEGORY_LIST_SUCCESS = `${url}/LOAD_PACKAGES_CATEGORY_LIST_SUCCESS`;
export const LOAD_PACKAGES_CATEGORY_LIST_ERROR = `${url}/LOAD_PACKAGES_CATEGORY_LIST_ERROR`;

export const LOAD_BEST_SELLING_DETAILS_IMAGES = `${url}/LOAD_BEST_SELLING_DETAILS_IMAGES`;
export const LOAD_BEST_SELLING_DETAILS_IMAGES_SUCCESS = `${url}/LOAD_BEST_SELLING_DETAILS_IMAGES_SUCCESS`;
export const LOAD_BEST_SELLING_DETAILS_IMAGES_ERROR = `${url}/LOAD_BEST_SELLING_DETAILS_IMAGES_ERROR`;
export const LOAD_DEALS_LIST = `${url}/LOAD_DEALS_LIST`;
export const LOAD_DEALS_LIST_SUCCESS = `${url}/LOAD_DEALS_LIST_SUCCESS`;
export const LOAD_DEALS_LIST_ERROR = `${url}/LOAD_DEALS_LIST_ERROR`;
export const LOAD_HOLIDAYS_LIST = `${url}/LOAD_HOLIDAYS_LIST`;
export const LOAD_HOLIDAYS_LIST_SUCCESS = `${url}/LOAD_HOLIDAYS_LIST_SUCCESS`;
export const LOAD_HOLIDAYS_LIST_ERROR = `${url}/LOAD_HOLIDAYS_LIST_ERROR`;
export const LOAD_TESTIMONIAL_LIST = `${url}/LOAD_TESTIMONIAL_LIST`;
export const LOAD_TESTIMONIAL_LIST_SUCCESS = `${url}/LOAD_TESTIMONIAL_LIST_SUCCESS`;
export const LOAD_TESTIMONIAL_LIST_ERROR = `${url}/LOAD_TESTIMONIAL_LIST_ERROR`;

export const CREATE_PAYMENT_IN_DETAILS = `${url}/CREATE_PAYMENT_IN_DETAILS`;
export const CREATE_PAYMENT_IN_DETAILS_SUCCESS = `${url}/CREATE_PAYMENT_IN_DETAILS_SUCCESS`;
export const CREATE_PAYMENT_IN_DETAILS_ERROR = `${url}/CREATE_PAYMENT_IN_DETAILS_ERROR`;

//category

export const UPDATE_PAYMENT_IN_DETAILS = `${url}/UPDATE_PAYMENT_IN_DETAILS`;
export const UPDATE_PAYMENT_IN_DETAILS_SUCCESS = `${url}/UPDATE_PAYMENT_IN_DETAILS_SUCCESS`;
export const UPDATE_PAYMENT_IN_DETAILS_ERROR = `${url}/UPDATE_PAYMENT_IN_DETAILS_ERROR`;

export const DELETE_PAYMENT_IN_DETAILS = `${url}/DELETE_PAYMENT_IN_DETAILS`;
export const DELETE_PAYMENT_IN_DETAILS_SUCCESS = `${url}/DELETE_PAYMENT_IN_DETAILS_SUCCESS`;
export const DELETE_PAYMENT_IN_DETAILS_ERROR = `${url}/DELETE_PAYMENT_IN_DETAILS_ERROR`;

export const LOAD_DYNAMIC_IMAGES_LIST_RECORDS_META_DATA = `${url}/LOAD_DYNAMIC_IMAGES_LIST_RECORDS_META_DATA`;
export const LOAD_DYNAMIC_IMAGES_LIST_RECORDS_META_DATA_SUCCESS = `${url}/LOAD_DYNAMIC_IMAGES_LIST_RECORDS_META_DATA_SUCCESS`;
export const LOAD_DYNAMIC_IMAGES_LIST_RECORDS_META_DATA_ERROR = `${url}/LOAD_DYNAMIC_IMAGES_LIST_RECORDS_META_DATA_ERROR`;
export const LOAD_RECORDS_VALID_CACHE = `${url}/LOAD_RECORDS_VALID_CACHE`;

const constants = {
  LOAD_DYNAMIC_IMAGES_LIST,
  LOAD_DYNAMIC_IMAGES_LIST_SUCCESS,
  LOAD_DYNAMIC_IMAGES_LIST_ERROR,
  LOAD_DESTINATION_LIST,
  LOAD_DESTINATION_LIST_SUCCESS,
  LOAD_DESTINATION_LIST_ERROR,
  LOAD_PACKAGES_CATEGORY_LIST,
  LOAD_PACKAGES_CATEGORY_LIST_SUCCESS,
  LOAD_PACKAGES_CATEGORY_LIST_ERROR,

  LOAD_BEST_SELLING_DETAILS_IMAGES,
  LOAD_BEST_SELLING_DETAILS_IMAGES_SUCCESS,
  LOAD_BEST_SELLING_DETAILS_IMAGES_ERROR,
  LOAD_DEALS_LIST,
  LOAD_DEALS_LIST_SUCCESS,
  LOAD_DEALS_LIST_ERROR,
  LOAD_TESTIMONIAL_LIST,
  LOAD_TESTIMONIAL_LIST_SUCCESS,
  LOAD_TESTIMONIAL_LIST_ERROR,
  LOAD_HOLIDAYS_LIST,
  LOAD_HOLIDAYS_LIST_SUCCESS,
  LOAD_HOLIDAYS_LIST_ERROR,

  CREATE_PAYMENT_IN_DETAILS,
  CREATE_PAYMENT_IN_DETAILS_SUCCESS,
  CREATE_PAYMENT_IN_DETAILS_ERROR,

  UPDATE_PAYMENT_IN_DETAILS,
  UPDATE_PAYMENT_IN_DETAILS_SUCCESS,
  UPDATE_PAYMENT_IN_DETAILS_ERROR,

  DELETE_PAYMENT_IN_DETAILS,
  DELETE_PAYMENT_IN_DETAILS_SUCCESS,
  DELETE_PAYMENT_IN_DETAILS_ERROR,

  LOAD_RECORDS_VALID_CACHE,

  LOAD_DYNAMIC_IMAGES_LIST_RECORDS_META_DATA,
  LOAD_DYNAMIC_IMAGES_LIST_RECORDS_META_DATA_SUCCESS,
  LOAD_DYNAMIC_IMAGES_LIST_RECORDS_META_DATA_ERROR,
};

export default constants;
